<template>
  <div class="py-2 my-2 help-container">
    <h1 class="separator py-4">DOCUMENTS</h1>
    <span class="banner py-3 mb-4">
      <div>Documents represent any supporting material for a budget. You will be able to upload various types of files and if desired, create folders to organize your files.</div>
      <div>Expand the topic below for more information on that step.</div>
    </span>

    <!--Help Sections-->
    <v-expansion-panels v-model="openSectionInternal">
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(0)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(0)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Documents</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <div>The Document page displays the name of the document, the date that the document was uploaded, the size of the document and the name of the person who uploaded the document.</div>
          <div>To add a new file, select the Documents icon on the left-hand navigation of the budget screen and then select +ADD DOCUMENT.</div>
          <div>To add a new folder select +NEW FOLDER.</div>
          <div>The Ellipsis (3 dots) drop-down will offer you options to Download, Edit Name or Delete your file.</div>
          <div>The document page will be available even if the rest of the budget is locked.</div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Prefer to watch a video? <a @click="openExternalTopic('BudgetsPro Documents')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Want to see all BudgetsPro help articles? <a @click="openExternalTopic('BudgetsPro')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import HelpMixin from '@/mixins/Help.js'
  export default {
    name: 'DocumentsHelp',
    mixins: [HelpMixin]
  }
</script>

<style lang="scss" scoped>
  .no-bullet {
    list-style-type: none;
  }
  .icon {
      order: 0;
  }
  .header {
      order: 1;
  }
  img {
    max-width: 650px;
  }
  img.small {
    width: 35px;
  }
  .help-container {
      border-bottom: 1px solid var(--v-resGrey-lighten1)
  }
  .help-content div,
  .help-content li {
      margin-top:10px !important;
      margin-bottom:10px !important;
  }
  .banner {
    text-align: center;
    background-color: var(--v-resGrey-lighten1);
    display: block;
  }
  .pointer {
      cursor: pointer !important;
  }
  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }
  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid var(--v-resGrey-darken1);
  }

  .separator:not(:empty)::before {
    margin-right: .25em;
  }

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
